import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
	Alignment,
	Button,
	Classes,
	Dialog,
	Icon,
	Navbar,
	Divider,
} from '@blueprintjs/core';

class InvoiceFiscalVerificationHistoryDialog extends Component {
	constructor(props) {
		super(props);
		
		const items = this.props.invoice_fiscal_verifications_by_id_invoice[this.props.id_invoice];
		this.state = {
			selected_id_invoice_fiscal_verification: items === null || items.length == 0 ? null : items[0].id_invoice_fiscal_verification,
		};
	}
	
	toLocalStringWithTime(date) {
		if (date === null) return '';
		
		return date.getDate().toString().padStart(2, '0') + '.' +
			(date.getMonth() + 1).toString().padStart(2, '0') + '.' +
			date.getFullYear() + ' ' +
			date.getHours().toString().padStart(2, '0') + ':' +
			date.getMinutes().toString().padStart(2, '0') + ':' +
			date.getSeconds().toString().padStart(2, '0');
	}
	
	getStatus(status) {
		if (status === null) {
			return 'v pošiljanju';
		}
		else if (status) {
			return 'potrjeno';
		}
		return 'napaka pri potrjevanju';
	}
	
	render() {
		const invoice = this.props.invoices[this.props.id_invoice];
		
		const invoice_fiscal_verifications_for_invoice =
			(this.props.invoice_fiscal_verifications_by_id_invoice === undefined ?
				undefined : this.props.invoice_fiscal_verifications_by_id_invoice[this.props.id_invoice]) || [];
		
		let sel_index = -1;
		for (let i=0; i<invoice_fiscal_verifications_for_invoice.length; i++) {
			if (this.state.selected_id_invoice_fiscal_verification == invoice_fiscal_verifications_for_invoice[i].id_invoice_fiscal_verification) {
				sel_index = i;
				break;
			}
		}
		
		return <Dialog
			isOpen={true}
			usePortal={true}
			canOutsideClickClose={false}
			canEscapeKeyClose={false}
			onClose={() => this.props.closeInvoiceFiscalVerificationHistoryDialog()}
			className='invoice-fiscal-verification-history-dialog'>
			<div className='flex flex-col flex-grow h-full'>
				<Navbar fixedToTop={false} className='bp5-dark'>
					<Navbar.Group>
						<Navbar.Heading>Zgodovina davčnega potrjevanja • {invoice.invoice_number_internal}</Navbar.Heading>
					</Navbar.Group>
					<Navbar.Group align={Alignment.RIGHT}>
						<Button minimal={true} icon='cross' onClick={() => this.props.closeInvoiceFiscalVerificationHistoryDialog()} />
					</Navbar.Group>
				</Navbar>
				<div className={Classes.DIALOG_BODY + ' flex flex-row items-stretch'} style={{ height: 'calc(100% - 70px)' }}>
					<div className='flex flex-1 flex-row items-stretch'>
						<div className='w-1/4 fiscal-verification-items overflow-y-auto'>
							{invoice_fiscal_verifications_for_invoice.map((invoice_fiscal_verification, statusIdx) => {
								let icon  = '';
								let color = '';
								if (invoice_fiscal_verification !== null) {
									if (invoice_fiscal_verification.status === null) {
										icon   = 'history';
										color  = '#d9822b';
									}
									else if (invoice_fiscal_verification.status) {
										icon   = 'tick-circle';
										color  = '#0f9960';
									}
									else {
										icon   = 'warning-sign';
										color  = '#db3737';
									}
								}
								
								const cls = invoice_fiscal_verification.id_invoice_fiscal_verification == this.state.selected_id_invoice_fiscal_verification ?
									'selected' : '';
								
								return <div
									key={'invoice-fiscal-verification-' + invoice_fiscal_verification.id_invoice_fiscal_verification}
									className={'fiscal-verification-item flex flex-row ' + cls}
									onClick={() => this.setState({ selected_id_invoice_fiscal_verification: invoice_fiscal_verification.id_invoice_fiscal_verification })}>
									<div className='w-1/6'>
										<Icon
											icon={icon}
											color={color} />
									</div>
									<div className='flex-1'>
										<div className={statusIdx == 0 ? 'font-bold' : ''}>{
											this.toLocalStringWithTime(new Date(invoice_fiscal_verification.created))
										}</div>
										<div className={statusIdx == 0 ? 'font-bold' : ''}>{
											this.getStatus(invoice_fiscal_verification.status)
										}</div>
									</div>
								</div>;
							})}
						</div>
						<div className='flex-1 fiscal-verification-messages overflow-y-scroll'>
							{sel_index == -1 ? null :
								<>
									<div className='text-center uppercase text-lg font-light'>Odgovor</div>
									<pre>{
										invoice_fiscal_verifications_for_invoice[sel_index].response === null ? null :
											JSON.stringify(JSON.parse(invoice_fiscal_verifications_for_invoice[sel_index].response), null, 2)
									}</pre>
									
									<Divider className='mt-4 mb-4' />
									
									{(() => {
										let request     = null;
										let sent_message = invoice_fiscal_verifications_for_invoice[sel_index].sent_message;
										
										if (sent_message !== null) {
											const sent_message_obj = JSON.parse(sent_message);
											if (sent_message_obj.token !== null) {
												const arr = sent_message_obj.token.split('.');
												if (arr.length == 3) {
													const request_obj = JSON.parse(atob(arr[1]));
													request = JSON.stringify(request_obj, null, 2);
												}
											}
										}
										
										return <>
											<div className='text-center uppercase text-lg font-light'>Zahtevek</div>
											<pre>{
												request
											}</pre>
										</>;
									})()}
								</>
							}
						</div>
					</div>
				</div>
			</div>
		</Dialog>;
	}
}

function mapStateToProps(state) {
	return {
		invoices: state.BusinessSlice.invoices,
		invoice_fiscal_verifications_by_id_invoice: state.BusinessSlice.invoice_fiscal_verifications_by_id_invoice,
	};
}

export default connect(mapStateToProps)(InvoiceFiscalVerificationHistoryDialog);
